export default "__VITE_ASSET__DIq6rqiP__"